import React from 'react';
import callApi from '../../utils/callApi';
import { UserContext } from '../../context/index.js'
import { FETCH_AUDITION_LIST } from '../../constants/apiUrls/apiUrls'

import Auditions from '../../components/auditionsComponents/Auditions'
import VideoPlayer from '../../components/videoComponents/VideoPlayer'
import LockedVideo from '../../components/videoComponents/LockedVideo'

import './css/Auditions.css';

class AuditionsPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
          isLoggedInUser: true,
          showVideo: false,
          showSegmentList: false,
          videoElement: null,

          isLoading: false,
          currentPageNumber: 1,
          totalNumberOfEntries: null,
          entriesPerPage: 12,
          auditions: []
        };
    }

    fetchAuditionList =  (id) => {
      const { currentPageNumber, entriesPerPage} = this.state;
      let url = FETCH_AUDITION_LIST.replace('{page}', (currentPageNumber - 1))
                                   .replace('{size}', entriesPerPage);
      callApi(url, 'get', {})
        .then(res => {
          const segments = res.data.segments.map(el => {
              el.title = this.appendAuditionString(el.title);
              return el;
            });
          if (id) {
            const videoElement = res.data.segments.filter( (audition, index) => audition.auditionId == id);
            const videoEl = { auditionId: id };
            this.setState({auditions: segments, totalNumberOfEntries: res.data.count, isLoading: false, videoElement: videoElement[0] || videoEl, showVideo: true, typeOfListing: 'amature-audition'})
          }else {
            this.setState({auditions: segments, totalNumberOfEntries: res.data.count, isLoading: false, videoElement: null, showVideo: false})
          }

        });
    }

  appendAuditionString = title => {
    if (title.indexOf('Audition') === -1) {
      return `${title}'s Audition`;
    } else {
      return title;
    }
  }

    loadMore = () => {
      const { isLoading, entriesPerPage } = this.state;
      this.setState({isLoading: true, entriesPerPage: entriesPerPage + 12}, () => this.fetchAuditionList());
    }

    getIdFromPath = () => {
      const { location } = this.props;
      const regex = /(-\d{1,})/;
      const found = location.pathname.match(regex);

      return found && found.length ? found[0].replace('-','') : false;
    }

    componentDidMount = () => {
      const { location } = this.props;
      const id = this.getIdFromPath();
      document.title = "Auditions | Naked News"
      this.fetchAuditionList(id);
    }

    decideVideoRender = () => {
      const { showVideo, showSegmentList, videoElement } = this.state;
      const { user } = this.props;
      const { activeSubscription } = this.context;
      const isLoggedIn = activeSubscription || false;
      const isSubscribed = user.user && user.user.activeSubscription;

      if (typeof videoElement === 'undefined' || videoElement === null) {
        return false;
      }

      if (showVideo) {
        if (!isSubscribed) {
          return (<LockedVideo videoElement={videoElement} typeOfListing={"audition"}/> );
        } else {
          return (<VideoPlayer user={user} isProgram={showSegmentList} videoElement={videoElement} typeOfListing={"audition"} key={videoElement.id}/>);
        }
      }

      return false;
    }

    render() {
        const { auditions, isLoading } = this.state;
        return (
          <div id='application'>
            { this.decideVideoRender() }
            <Auditions auditions={auditions} isLoading={isLoading} loadMore={this.loadMore}/>
          </div>
        );
    }
}

AuditionsPage.contextType = UserContext;

export default AuditionsPage;
